import React from 'react';
import PropTypes from 'prop-types';
import DrawerAnchor from '../UI/DrawerAnchor';
import CommentsDataStore from './containers/commentsDataStore';
import Comments from './Comments/Comments';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import './conversationDrawer.less';
import WindowSizeThresholdsEnum from '../../enums/WindowSizeThresholdsEnum';

ConversationDrawer.propTypes = {
	type: PropTypes.object,
	id: PropTypes.string,
	communityId: PropTypes.number,
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	isOwner: PropTypes.bool,
	isMobile: PropTypes.func,
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
};

function ConversationDrawer({
	type,
	id,
	communityId,
	text,
	isOwner,
	isMobile,
	children,
}) {
	const isMobileSize = isMobile();
	return (
		<DrawerAnchor
			drawerClassName="conversation-drawer"
			closable={true}
			width={isMobileSize ? '100%' : '900'}
			placement={isMobileSize ? 'bottom' : 'right'}
			height={isMobileSize ? '90%' : '100%'}
			renderDrawerContent={() => {
				return (
					<CommentsDataStore type={type} id={id} results={6}>
						<Comments
							communityId={Number(communityId)}
							text={text}
							isOwner={isOwner}
							conversationId={parseInt(id)}
							isMobile={isMobileSize}
						/>
					</CommentsDataStore>
				);
			}}>
			{children}
		</DrawerAnchor>
	);
}

export default withIsMobile(
	ConversationDrawer,
	WindowSizeThresholdsEnum.Medium,
);
